import type { UserAgent } from './types';

const createTrackingWrapper = (htmlContent: string): void => {
  const wrapper = document.createElement('div');
  wrapper.style.height = '1px';
  wrapper.style.left = '1px';
  wrapper.style.position = 'absolute';
  wrapper.style.top = '1px';
  wrapper.style.width = '1px';
  wrapper.style.zIndex = '99999';
  wrapper.innerHTML = htmlContent;
  document.body.appendChild(wrapper);
};

export const getUserAgent = (): UserAgent => {
  if (!navigator) return {};
  const { userAgent, cookieEnabled } = navigator;

  return {
    userAgent,
    cookieEnabled,
  };
};

export const TrackerUtils = {
  createTrackingWrapper,
  getUserAgent,
};
